// removes a key from the query string. Example,
// "www.google.com?utm_term=hi" --> removeQueryString("utm_term") --> "www.google.com?"
export function removeQueryString(keyToRemove) {
  let search = document.location.search;
  if (search === "" || search.indexOf(keyToRemove) === -1) {
    return;
  }

  // remove the "?" from the search string
  search = search.substring(1);

  const keyAndValues = search.split("&");
  document.location.search = keyAndValues
    .filter(function(keyAndValue) {
      const key = keyAndValue.split("=")[0];
      return key !== keyToRemove;
    })
    .join("&");
}
